import { Directive } from "@angular/core";

/**
 * Wrapper for table content in a mat-card with specialized styling.
 * Provides consistent background and spacing for data tables within cards.
 *
 * @example
 * <mat-card>
 *   <mgd-card-list-table>
 *     <table mat-table [dataSource]="dataSource">
 *       <!-- table content -->
 *     </table>
 *   </mgd-card-list-table>
 * </mat-card>
 */
@Directive({
    selector: "mgd-card-list-table",
    host: {
        class: "mgd-card-list-table"
    }
})
export class CardListTableDirective {}
